import React from "react";
import Modal from "react-responsive-modal";
import { Ban } from "lucide-react";
import { CancellationModalProps } from "../interfaces";
import { SpinnerCircularFixed } from "spinners-react";

export const CancellationModal: React.FC<CancellationModalProps> = ({
  closeModal,
  existsNfcPayments,
  isLoading,
  makeRefund,
  open,
  orderCode,
}) => {
  return (
    <Modal
      classNames={{
        modal: `bg-white w-auto sm:w-[550px] rounded-2xl shadow-modal !p-0`,
        overlay: `bg-modal-overlay`,
      }}
      showCloseIcon={false}
      open={open}
      onClose={closeModal}
      center
      focusTrapped={false}
    >
      <div className="p-8 sm:p-8 sm:pb-6">
        <h1 className="border-b border-gray-200 pb-4 text-xl font-bold text-gray-900">
          Confirmar cancelación
        </h1>
        <div className="mb-10 mt-6 flex flex-col gap-2">
          <h2 className="font-semibold text-gray-900">
            Advertencia importante:
          </h2>
          <p className="text-gray-600">
            Esta acción cancelará la orden{" "}
            <span className="font-bold text-black">{orderCode}</span> de forma
            irreversible y no podrá ser recuperada después de confirmar.
          </p>
          {existsNfcPayments && (
            <p className="mt-2 text-gray-600">
              <span className="font-semibold text-gray-900">Nota:</span> Los
              pagos con tarjeta Yoshi se deberán reembolsar de forma manual.
            </p>
          )}
        </div>
        <div className="flex flex-col justify-end gap-3 sm:flex-row">
          <button
            className="h-12 rounded-lg border border-gray-200 bg-white px-6 py-2 text-sm text-gray-900 transition-colors duration-300 hover:bg-gray-100"
            onClick={closeModal}
          >
            Descartar
          </button>
          <button
            className="flex h-12 items-center justify-center gap-2 rounded-lg bg-red-600 px-6 py-2 text-sm text-white transition-colors duration-300 hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
            disabled={isLoading}
            onClick={makeRefund}
          >
            {isLoading ? (
              <SpinnerCircularFixed
                size={16}
                color="#FFFFFF"
                secondaryColor="#000000"
              />
            ) : (
              <Ban className="h-4 w-4 shrink-0" />
            )}
            Confirmar cancelación
          </button>
        </div>
      </div>
    </Modal>
  );
};
